import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { postPackWidget, deletePackWidget, deleteParticipantPitch } from '../actions';
import SMTeamLogo from '../../../../widgets/components/sm/views/SMTeamLogo';
import SMPlayerLogo from '../../../../widgets/components/sm/views/playerLogo/SMPlayerLogo';
import ListItem from 'material-ui/List/ListItem';

const Draggable = styled.div`
    border-bottom: 1px solid rgb(224, 224, 224);
    transition: all 0.2s ease;
    cursor: pointer;

    :focus,
    :hover {
        background: rgba(0, 0, 0, 0.1);
    }
`;

const ListItemStyle = {
    pointerEvents: 'none',
    cursor: 'pointer'
};

class ItemParticipant extends Component {
    getAvatar() {
        const { id, type, participant } = this.props;

        switch (type) {
            case 'players':
                return (
                    <SMPlayerLogo
                        teamId={participant.team ? participant.team.id : 0}
                        playerId={id}
                        seasonId="current"
                        isGK={participant.position === 'keeper'}
                        size="original"
                        width={40}
                        height={40}
                        resetImageWrapStyle
                    />
                );
            case 'teams':
                return <SMTeamLogo teamId={id} width={40} />;
        }
    }

    dragStart = event => {
        event.dataTransfer.setData('participant', JSON.stringify(this.props.participant));
    };

    drop = action => event => {
        const position = event.dataTransfer.getData('position');

        if (position) {
            action(position);
            event.dataTransfer.clearData();
        }
    };

    dragEnd = event => {
        event.dataTransfer.clearData();
    };

    render() {
        const { id = 0, participant = {}, isDisplay = true, isActive, deleteParticipantPitch } = this.props;

        return (
            <Draggable
                id={id}
                hidden={!isDisplay}
                draggable
                onDrop={this.drop(deleteParticipantPitch)}
                onDragStart={this.dragStart}
                onDragOver={event => event.preventDefault()}
                onDragEnd={this.dragEnd}
            >
                <ListItem
                    primaryText={participant.name}
                    leftAvatar={this.getAvatar()}
                    innerDivStyle={isActive ? { backgroundColor: 'rgba(0, 0, 0, 0.05)' } : {}}
                    style={ListItemStyle}
                    // nestedListStyle={ListItemStyle}
                />
            </Draggable>
        );
    }
}

ItemParticipant.propTypes = {
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    // From connect
    participant: PropTypes.object.isRequired,
    isDisplay: PropTypes.bool.isRequired,
    isActive: PropTypes.bool,
    deleteParticipantPitch: PropTypes.func.isRequired
};

export default connect(
    ({ makerToolPage = {}, requery = { entities: {} } }, { id = 0, type = '' }) => {
        const participant = requery.entities && requery.entities[type] && requery.entities[type][id];
        const searchInputText = makerToolPage.searchInputText;

        return {
            participant: participant,
            isDisplay: searchInputText ? participant.name.toLowerCase().includes(searchInputText.toLowerCase()) : true,
            isActive: !!makerToolPage.activeParticipants[id]
        };
    },
    { postPackWidget, deletePackWidget, deleteParticipantPitch }
)(ItemParticipant);



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/ItemParticipant.js
 **/